import { OfficeRouteItemType, } from '@office-start/officehome-types';
export function getOfficeRouteItemFromRoute(route, params) {
    if (!params) {
        return {
            route: route,
            type: OfficeRouteItemType.Base,
        };
    }
    switch (route) {
        case 'M365Apps':
            return {
                app: params.appId,
                appId: params.appId,
                entityId: params.entityId,
                route: route,
                subPageId: params.subPageId,
                type: OfficeRouteItemType.Mos,
            };
        case 'MyContent':
            return {
                app: params.app,
                route: route,
                type: OfficeRouteItemType.Base,
                entityId: params.entityId,
                subEntityId: params.subEntityId,
            };
        default:
            return {
                app: params.app,
                route: route,
                type: OfficeRouteItemType.Base,
            };
    }
}
//# sourceMappingURL=getOfficeRouteItemFromRoute.js.map